import React from "react";

import EmptyChart from "../../../../../../components/EmptyChart";
import Spinner from "../../../../../../components/Spinner/QuarterCircle";
import Text from "../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../components/Card";
import ScatterChart from "../../../../components/ScatterChart";
// hooks
import useScatterChart from "../../../../components/ScatterChart/useScatterChart";

// store
import useStore from "../../../../store";

import { useFactorComparison } from "../../../../../../api/hooks";

// css
import css from "./enpsOverallScatter.module.scss";

const enpsOverallScatter = () => {
	const [filter] = useStore((state) => [state.filter]);

	const xAxis = "eNPS";
	const yAxis = "all";

	const { data, isLoading } = useFactorComparison({
		xAxis,
		yAxis,
		startDate: filter.startDate ? filter.startDate : undefined,
		endDate: filter.endDate,
	});

	const { options, prepareDataForChart, getScaledOptions } = useScatterChart({
		xAxisLabel: "eNPS Rating",
		yAxisLabel: "Satisfaction",
		data: data || [],
	});

	const scaledOptions = getScaledOptions(
		{
			...(data?.length
				? {}
				: {
						min: 0,
						max: 10,
					}),
			ticks: {
				...options.scales?.x?.ticks,
				stepSize: 2,
			},
		},
		{
			min: 1,
			max: 5,
		}
	);

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							eNPS vs. Satisfaction
						</Text>
					</span>
				}
				info="This chart displays individual points for each anonymous employee comparing their eNPS rating to their overall satisfaction for the selected period."
			/>
			<CardBody>
				<div className={css.cardBody}>
					{!isLoading && !data?.length ? (
						<EmptyChart type="scatterSmall" />
					) : isLoading ? (
						<div className={css.spinner}>
							<Spinner />
						</div>
					) : (
						<div className={css.scatterChart}>
							<ScatterChart data={prepareDataForChart()} options={scaledOptions} />
						</div>
					)}
				</div>
			</CardBody>
		</>
	);
};

export default enpsOverallScatter;
